document.querySelectorAll(".delivery_returns-content .tab").forEach(tab => {
  tab.addEventListener("click", function() {
      // Remove 'current' class from all tabs and contents
      document.querySelectorAll(".delivery_returns-content .tab").forEach(t => t.classList.remove("current"));
      document.querySelectorAll(".delivery_returns-content .tab-content").forEach(c => c.classList.remove("current"));

      // Add 'current' class to the clicked tab
      this.classList.add("current");

      // Show corresponding content
      const target = this.getAttribute("data-target");
      document.getElementById(target).classList.add("current");
  });
});
document.querySelectorAll(".size-chart-content-tabs .tab").forEach(tab => {
  tab.addEventListener("click", function() {
      // Remove 'current' class from all tabs and contents
      document.querySelectorAll(".size-chart-content-tabs .tab").forEach(t => t.classList.remove("current"));
      document.querySelectorAll(".size-chart-content-tabs .tab-content").forEach(c => c.classList.remove("current"));

      // Add 'current' class to the clicked tab
      this.classList.add("current");

      // Show corresponding content
      const target = this.getAttribute("data-target");
      document.getElementById(target).classList.add("current");
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const passwordInput = document.querySelector(".show_password_input");
  const toggleButton = document.querySelector(".show_password");

  if(passwordInput  && toggleButton)
  {
    toggleButton.addEventListener("click", function () {
        const isPassword = passwordInput.getAttribute("type") === "password";
        passwordInput.setAttribute("type", isPassword ? "text" : "password");
    });
  }
});